import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { HttpRequestService } from 'src/app/core/services';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-test-insight',
  templateUrl: './test-insight.component.html',
  styleUrls: ['./test-insight.component.scss'],
})
export class TestInsightComponent implements OnInit, OnChanges {
  @Input() value: any = {};
  @Input() testId?: string;

  allAttended: any[] = [];
  totalAttended = 0;
  topCollapsed = false;
  allCollapsed = false;

  pageSize = 10;
  pageIndex = 1;
  totalAllAttended = 0;
  loading = false;

  searchTestInsight: Subject<string> = new Subject<string>();
  search = '';
  startDate: any;
  endDate: any;
  dateRange: any;

  constructor(
    private httpRequestService: HttpRequestService,
    private notification: NzNotificationService,
  ) {}

  ngOnInit(): void {
    // Debounced search
    this.searchTestInsight
      .pipe(debounceTime(800))
      .subscribe((value: string) => {
        this.search = value;
        if (this.testId) {
          this.loadInsights(this.testId, 0, this.pageSize);
        }
      });

    this.applyValue();
  }
  convertMinutes(min: number): string {
    const h = Math.floor(min / 60);
    const m = min % 60;
    return h ? `${h}h ${m}m` : `${m}m`;
  }
  ngOnChanges(changes: SimpleChanges): void {
    // When testId changes
    if (changes['testId'] && this.testId) {
      this.loadInsights(this.testId, 0, this.pageSize);
    }

    // When initial value changes
    if (changes['value']) {
      this.applyValue();
    }
  }

  private applyValue(): void {
    const data = this.value ? this.value : null;

    // FIXED: corrected wrong property
    this.allAttended = data && Array.isArray(data.users) ? data.users : [];

    this.totalAttended =
      data && typeof data.totalAttended === 'number'
        ? data.totalAttended
        : this.allAttended.length;

    this.totalAllAttended = this.totalAttended;
  }

  // Search input
  searchTestWithName(value: string): void {
    this.searchTestInsight.next(value);
  }

  // Table pagination event
  onQueryParamsChange(params: NzTableQueryParams): void {
    const { pageSize, pageIndex } = params;
    this.pageSize = pageSize;
    this.pageIndex = pageIndex;

    const skip = pageSize * (pageIndex - 1);

    if (this.testId) {
      this.loadInsights(this.testId, skip, pageSize);
    }
  }

  onChangeDateRange(date: any): void {
    this.startDate = date?.[0];
    this.endDate = date?.[1];

    if (this.testId) {
      this.loadInsights(this.testId, 0, this.pageSize);
    }
  }

  loadInsights(testId: string, skip = 0, limit = 10): void {
    if (!testId) return;

    this.loading = true;

    const params: any = { skip, limit };

    if (this.search) params.search = this.search;

    if (this.startDate && this.endDate) {
      params.startDate = this.startDate;
      params.endDate = this.endDate;
    }

    this.httpRequestService
      .request('get', `answer-sheets/leaderboard-data/${testId}`, params)
      .subscribe(
        (res: any) => {
          this.loading = false;

          const data = res.data || res;
          this.allAttended = Array.isArray(data.users) ? data.users : [];
          this.totalAllAttended = data.totalAttended || this.allAttended.length;
        },
        () => {
          this.loading = false;
          this.notification.error('', 'Failed to load insights');
        },
      );
  }

  formatPercentile(val: any): string {
    if (val === null || val === undefined || val === '') return '-';
    const s = String(val).trim();
    return s.endsWith('%') ? s : `${s}%`;
  }

  getMarkTagColor(marks: number): string {
    if (marks == null) return 'default';
    if (marks > 0) return 'green';
    if (marks === 0) return 'orange';
    return 'red';
  }

  getInitial(name?: string): string {
    if (!name) return '';
    return name.trim().charAt(0).toUpperCase();
  }

  toggleTop(): void {
    this.topCollapsed = !this.topCollapsed;
  }

  toggleAll(): void {
    this.allCollapsed = !this.allCollapsed;
  }
}
